export enum TallyConstantKey {
  SupplierIntelligenceBasePath = "supplierIntelligenceBasePath",
  TallyMainPageImageUrl = "tallyMainPageImageUrl",
  TallyIntegrationStep1VideoUrl = "tallyIntegrationStep1VideoUrl",
  TallyIntegrationStep2VideoUrl = "tallyIntegrationStep2VideoUrl",
  TallyIntegrationStep3VideoUrl = "tallyIntegrationStep3VideoUrl",
  TallyIntegrationStep4VideoUrl = "tallyIntegrationStep4VideoUrl",
  TallySupportMobileNumber = "tallySupportMobileNumber",
}

type TallyConstantValues = Record<TallyConstantKey, string>;

export class TallyConstants {
  private static readonly appConfig: Partial<TallyConstantValues> = {};

  private static readonly defaults: TallyConstantValues = {
    [TallyConstantKey.SupplierIntelligenceBasePath]: "/supplier-intelligence",
    [TallyConstantKey.TallyMainPageImageUrl]:
      "https://meritoassets.s3.ap-south-1.amazonaws.com/Website-Assets/Tally_Assets/Tally_Main_Page.png",
    [TallyConstantKey.TallyIntegrationStep1VideoUrl]:
      "https://meritoassets.s3.ap-south-1.amazonaws.com/Website-Assets/Tally_Assets/Tally_Integration_Step_1.mp4",
    [TallyConstantKey.TallyIntegrationStep2VideoUrl]:
      "https://meritoassets.s3.ap-south-1.amazonaws.com/Website-Assets/Tally_Assets/Tally_Integration_Step_2.mp4",
    [TallyConstantKey.TallyIntegrationStep3VideoUrl]:
      "https://meritoassets.s3.ap-south-1.amazonaws.com/Website-Assets/Tally_Assets/Tally_Integration_Step_3.mp4",
    [TallyConstantKey.TallyIntegrationStep4VideoUrl]:
      "https://meritoassets.s3.ap-south-1.amazonaws.com/Website-Assets/Tally_Assets/Tally_Integration_Step_4.mp4",
    [TallyConstantKey.TallySupportMobileNumber]: "919482851777",
  };

  static get(key: TallyConstantKey): string {
    return TallyConstants.appConfig[key] ?? TallyConstants.defaults[key];
  }
}
